import { Icon } from "@iconify/react/dist/iconify.js";
import { ComponentConfig, FieldLabel } from "@measured/puck";
import { Editor } from "@tinymce/tinymce-react";
import { useState } from "react";

// @ts-ignore
const WysiwygField: ComponentConfig = {
    fields: {
        editor: {
            type: "custom",
            render: ({ field, name, onChange, value }) => {
                return (
                    <FieldLabel label={field.label || name} icon={<Icon icon={'gala:editor'} width={16} height={16} />}>

                        <Editor
                            tinymceScriptSrc='/build/assets/tinymce/tinymce.min.js'
                            init={{
                                menubar: false,
                                plugins: 'link lists fullscreen wordcount',
                                paste_as_text: true,
                                height: 300,
                                toolbar: 'p h1 h2 h3 h4 h5 h6 | superscript subscript | formatselect undo redo | fullscreen | bold italic underline strikethrough | link | align | removeformat | numlist bullist | wordcount',
                                // color_map: [
                                //     // Color - Name
                                //     '#E8EEF2', 'arcticMist',
                                //     '#151545', 'midnightNavy',
                                //     '#393ABF', 'royalPeriwinkle',
                                //     '#130E2E', 'deepIndigo',
                                //     '#EF8126', 'accordorange',
                                //     '#1E1FAB', 'electricBlue',
                                //     '#06112E', 'shadowNavy',
                                //     '#030918', 'midnightAbyss',
                                //     '#4B4B73', 'slateGray',
                                //     '#E11143', 'crimsonAlert',
                                //     '#FFAC0C', 'goldenrod',
                                //     '#1B9C28', 'emeraldPulse',
                                // ]
                            }}
                            value={value}
                            // @ts-ignore
                            onEditorChange={(newValue, editor) => onChange(editor.getContent())}
                        />
                    </FieldLabel>
                )
            },
        },
    },
};

export default WysiwygField;